<div class="pb-50 pt-20">
  <div class="container">
    <div class="row mb-3">
      <app-article [pageName]="'DASHBOARD'" (pageTeacherDataLoaded)="handlePageData($event)"></app-article>
      <div class="col-lg-8 col-md-12 col-sm-12 col-12">
        <div class="card tea__top_card px-15 mt-15">
          <app-complete-profile-chart [profilePercentage]="teacherProfile"></app-complete-profile-chart>

        </div>
        <div class="d-flex justify-content-between align-items-center mt-20">
          <h5 class="text-regular-bold fs-16 mb-0">Jobs for you</h5>
          <!-- @if((promotedJobs?.length > 0) || (nonPromotedJobs?.length > 0)) {
          <a appFocus class="clr-cc-vilot fs-16 text-regular-bold" (click)="goTojobs()" role="button">View all jobs
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"
              viewBox="0 0 16 17" stroke="currentColor" stroke-width="1">
              <path fill-rule="evenodd"
                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
            </svg>
          </a>
          } -->
        </div>
        @if(email_job_alert_near == false && !schoolProps.properties.is_qld_teacher) {
        <div class="card mt-15">
          <div class="job__alerts d-flex">
            <div class="form-check form-switch">
              <input aria-describedby="jobalert jobalertHint" type="checkbox" role="switch" id="delay-send"
                class="form-check-input delay-send form__switch_cc c-p" [checked]="email_job_alert_near"
                (change)="getJobAlert($event)" />
            </div>

            <div class="ml-5">
              <p id="jobalert" class="text-regular-medium">Get job alerts</p>
              <p id="jobalertHint" class="mt-5 txt-regular">
                Notify me when jobs matching my job alert are posted.
              </p>
            </div>
          </div>
        </div>
        }
        <div class="main-content">

          @if((promotedJobs?.length > 0) || (nonPromotedJobs?.length > 0)) {

          <!-- ================= PROMOTED JOBS ================= -->
          @for (item of promotedJobs; track $index) {

          <div class="card px-23 mt-15" role="listitem">

            <div>
              @if(item.is_boost_job) {
              <p [id]="'promoted_job_promoted_' + $index" class="job_promoted">
                Promoted
              </p>
              }

              <!-- Save / Unsave Button -->
              <!-- <button type="button" class="save_jobIcon btn-reset" [attr.aria-pressed]="item.saved_status"
                [attr.aria-describedby]="
          'promoted_jobTitle_' + $index + ' ' +
          'promoted_schoolTitle_' + $index + ' ' +
          'promoted_location_' + $index
        " (click)="jobSaveUnsaveAPI(item.id, item.saved_status ? 'unsave' : 'save')">

                <i class="bi" [ngClass]="item.saved_status ? 'bi-bookmark-fill' : 'bi-bookmark'" aria-hidden="true">
                </i>

                <span class="visually-hidden">
                  {{ item.saved_status ? 'Unsave job' : 'Save job' }}
                </span>
              </button> -->
            </div>

            <div class="row align-items-center mt-3">
              <div class="col-12 d-flex">

                <img class="profile_teacher img-complete-match"
                  [src]="item?.school?.profile_image || '../../../../assets/images/teacher-static-profile.png'"
                  [alt]="item?.school?.title + ' school logo'" />

                <div class="ml-10">

                  <div class="d-flex align-items-center">
                    <span [id]="'promoted_schoolLevel_' + $index" class="txt-regular grey-4">
                      {{ item?.school_level }}
                    </span>

                    <span class="txt-regular grey-4 mr__10">&nbsp;.&nbsp;</span>

                    <span [id]="'promoted_jobType_' + $index" class="txt-regular grey-4">
                      {{ item?.job_type }}
                    </span>
                  </div>

                  <h5 [id]="'promoted_jobTitle_' + $index" class="text-r-m-16 mb-0 mt-3">
                    {{ item?.job_title }}
                  </h5>

                  <p [id]="'promoted_schoolTitle_' + $index" class="txt-regular mt-5">
                    {{ item?.school?.title }}
                  </p>

                  <p [id]="'promoted_location_' + $index" class="txt-regular">
                    {{ item?.suburb }}, {{ item?.state }}
                  </p>

                </div>
              </div>
            </div>
          </div>
          }

          <!-- ================= NON PROMOTED JOBS ================= -->
          @for (item of nonPromotedJobs; track $index) {

          <div class="card px-23 mt-15" role="listitem">

            <div>

              <!-- <button type="button" class="save_jobIcon btn-reset" [attr.aria-pressed]="item.saved_status"
                [attr.aria-describedby]="
          'normal_jobTitle_' + $index + ' ' +
          'normal_schoolTitle_' + $index + ' ' +
          'normal_location_' + $index
        " (click)="jobSaveUnsaveAPI(item.id, item.saved_status ? 'unsave' : 'save')">

                <i class="bi" [ngClass]="item.saved_status ? 'bi-bookmark-fill' : 'bi-bookmark'" aria-hidden="true">
                </i>

                <span class="visually-hidden">
                  {{ item.saved_status ? 'Unsave job' : 'Save job' }}
                </span>
              </button> -->
            </div>

            <div class="row align-items-center mt-3">
              <div class="col-12 d-flex">

                <img class="profile_teacher img-complete-match"
                  [src]="item?.school?.profile_image || '../../../../assets/images/teacher-static-profile.png'"
                  [alt]="item?.school?.title + ' school logo'" />

                <div class="ml-10">

                  <div class="d-flex align-items-center">
                    <span class="txt-regular grey-4">
                      {{ item.school_level }}
                    </span>

                    <span class="txt-regular grey-4 mr__10">&nbsp;.&nbsp;</span>

                    <span class="txt-regular grey-4">
                      {{ item.job_type }}
                    </span>
                  </div>

                  <h5 [id]="'normal_jobTitle_' + $index" class="text-r-m-16 mb-0 mt-3">
                    {{ item.job_title }}
                  </h5>

                  <p [id]="'normal_schoolTitle_' + $index" class="txt-regular mt-5">
                    {{ item.school.title }}
                  </p>

                  <p [id]="'normal_location_' + $index" class="txt-regular">
                    {{ item.suburb }}, {{ item.state }}
                  </p>

                </div>
              </div>
            </div>
          </div>
          }

          } @else {

          <!-- ================= EMPTY STATE ================= -->
          <div class="card pt-30 pb-30 mt-15">
            <div class="text-center py-3">
              <img src="assets/PendingInvites_NoHistoryFound.png" alt="" aria-hidden="true" class="img-fluid mb-3" />

              <p class="txt-regular">No jobs at the moment</p>
            </div>
          </div>

          }

        </div>
        <div class="main-bottom-content">
          <div class="d-flex justify-content-between align-items-center mt-20">
            <h5 class="text-regular-bold fs-16 mb-0">Popular PD Courses</h5>
            <a class="clr-cc-vilot fs-16 text-regular-bold" target="_blank" href="{{promotion_course?.[0]?.cta_link}}"
              role="button">Go to ClassCover Learn
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                class="bi bi-arrow-right" viewBox="0 0 16 17" stroke="currentColor" stroke-width="1">
                <path fill-rule="evenodd"
                  d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
              </svg>
            </a>
          </div>
          <p class="txt-regular course__badge mt-10 mb-15">
            Upgrade to a ClassCover Learn membership for unlimited access to our
            PD course library.
          </p>
          <ng-container *ngIf="paidCourses && paidCourses.length > 0; else noSchools">
            <carousel appFocus [itemsPerSlide]="itemsPerSlide" [singleSlideOffset]="false" [isAnimated]="true"
              [interval]="0" [indicatorsByChunk]="false" [showIndicators]="false" aria-label="Paid courses carousel">

              <slide *ngFor="let slide of paidCourses; let index = index">

                <div class="card px-15 m-1" role="group" [attr.aria-labelledby]="'courseTitle_' + index">

                  <!-- Image -->
                  <div class="text-center">
                    <img [src]="slide.image || 'assets/images/pro_avatar.png'" [alt]="slide.title + ' course image'"
                      class="img-fluid mb-3" style="
              object-fit: cover;
              height: 100px;
              width: 100%;
              border-radius: 8px;
            " />
                  </div>

                  <!-- Title -->
                  <h5 class="text-regular-bold mt-10" [id]="'courseTitle_' + index">
                    {{ slide.title }}
                  </h5>

                  <!-- Presenter -->
                  <p class="text-r-g-3 fs-12" [id]="'coursePresenter_' + index">
                    By {{ slide.presenter }}
                  </p>

                  <!-- Accessible Button Instead of Anchor -->
                  <button type="button" appFocus class="user-title-m mt-5 clr-cc-vilot c-p"
                    (click)="viewDetails(slide.link)"
                    [attr.aria-label]="'View details for ' + slide.title + ' by ' + slide.presenter">
                    View details
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-arrow-right" viewBox="0 0 16 17" stroke="currentColor" stroke-width="1"
                      aria-hidden="true" focusable="false">
                      <path fill-rule="evenodd"
                        d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                    </svg>
                  </button>

                </div>
              </slide>
            </carousel>
          </ng-container>
          <ng-template #noSchools>
            <div class="text-center text-muted py-3">No data found.</div>
          </ng-template>
        </div>
      </div>
      <div class="col-lg-4 col-md-12 col-sm-12 col-12">
        <div class="d-flex justify-content-between align-items-center mt-20">
          <h5 class="text-regular-bold fs-16">Your upcoming booking</h5>
        </div>
        <div class="card">
          @if(upcomingBookings && upcomingBookings.length > 0) {
          <div class="row align-items-center">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex">
              <div class="d-flex">
                <div class="cus_background">
                  <p class="txt-regular text-center clr-white date-top">
                    {{ upcomingBookings[0].date?.split(" ")[0] }}
                  </p>
                  <p class="txt-regular text-center clr-white date-bottom mt-5">
                    {{ upcomingBookings[0].date?.split(" ")[1] }}
                  </p>
                </div>
                <div class="px-10">
                  <h5 class="text-regular-bold align-self-center mb-0 mt-3">
                    {{ upcomingBookings[0].school_name }}
                  </h5>
                  <div class="d-flex align-items-center mt-1">
                    <span class="txt-regular">{{
                      upcomingBookings[0].booking_role_type
                      }}</span>
                    <span class="txt-regular mr__10">&nbsp;.&nbsp;</span>
                    <span class="txt-regular">{{ upcomingBookings[0].start_time }} -
                      {{ upcomingBookings[0].end_time }}</span>
                  </div>
                  <div class="d-flex align-items-center mt-1">
                    <span class="txt-regular">{{
                      upcomingBookings[0].class_being_covered
                      }}</span>
                    @if(upcomingBookings[0].teacher_being_covered !== null &&
                    upcomingBookings[0].teacher_being_covered !== '') {
                    <span class="txt-regular mr__10">&nbsp;.&nbsp;</span>
                    }
                    <span class="txt-regular">{{
                      upcomingBookings[0].teacher_being_covered
                      }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          } @else {
          <div class="text-center mt-3 mb-3 px-20 d-flex  align-items-center">
            <img alt="img" class="img-fluid" style="max-width: 80px;" src="assets/PendingInvites_NoHistoryFound.png" />
            <p class="user-title-m ml-10">No upcoming bookings</p>
          </div>
          }
        </div>
        <div>
          <div class="d-flex justify-content-between align-items-center mt-20">
            <h5 class="text-regular-bold fs-16">Calendar</h5>
          </div>
          <div class="card px-15">
            <div class="row mb-3">
              <app-availability-chart [sendProfileComData]="availability_health"></app-availability-chart>
            </div>
            <hr class="mt-15 mb-15" />

            <!-- Calendar Navigation -->
            <div class="row align-items-center mb-3">
              <button appFocus (click)="prevClick()" class="col txt-regular clr-grey-2 text-start c-p">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-arrow-left" viewBox="0 0 16 19" stroke="currentColor" stroke-width="1">
                  <path fill-rule="evenodd"
                    d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8" />
                </svg>
                Previous
              </button>
              <div class="col user-title text-center fs-14">
                {{ date_month }}
              </div>
              <button appFocus (click)="nextClick()" class="col txt-regular clr-grey-2 text-end c-p">
                Next
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                  class="bi bi-arrow-right" viewBox="0 0 16 19" stroke="currentColor" stroke-width="1">
                  <path fill-rule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                </svg>
              </button>
            </div>

            <!-- Dates Row -->
            <div class="date_calendar mt-15">
              <div class="row text-center mb-2 line_height_date">
                @for (item of teacher_fortnight?.availability; track $index) {
                <div class="col">
                  <p class="day-label txt-regular">{{ item.day }}</p>
                  <span class="date-label"><small><span class="date-day txt-regular">{{ item.date }}</span>
                      <span class="date-month txt-regular">{{
                        item.month
                        }}</span></small></span>
                </div>
                }
              </div>
              <!-- Calendar Color Codes -->
              <div class="row text-center mb-4 mt-10">
                @for (item of teacher_fortnight?.availability; track $index) {
                <div class="col" *ngIf="
                    item.intervals[0].status == 'haventindicated' &&
                    item.day !== 'Sat' &&
                    item.day !== 'Sun'
                  ">
                  <div class="calendar-box {{ item.intervals[0].status }}">
                    <span class="{{ item.intervals[0].status }}">HI</span>
                  </div>
                </div>
                <div class="col" *ngIf="
                    item.intervals[0].status == 'booked' &&
                    item.day !== 'Sat' &&
                    item.day !== 'Sun'
                  ">
                  <div class="calendar-box {{ item.intervals[0].status }}">
                    <span class="{{ item.intervals[0].status }}">B</span>
                  </div>
                </div>
                <div class="col" *ngIf="
                    item.intervals[0].status == 'unavailable' &&
                    item.day !== 'Sat' &&
                    item.day !== 'Sun'
                  ">
                  <div class="calendar-box {{ item.intervals[0].status }}">
                    <span class="{{ item.intervals[0].status }}">UA</span>
                  </div>
                </div>
                <div class="col" *ngIf="
                    item.intervals[0].status == 'booked_externally' &&
                    item.day !== 'Sat' &&
                    item.day !== 'Sun'
                  ">
                  <div class="calendar-box {{ item.intervals[0].status }}">
                    <span class="{{ item.intervals[0].status }}">BE</span>
                  </div>
                </div>
                <div class="col" *ngIf="
                    item.intervals[0].status == 'available' &&
                    item.day !== 'Sat' &&
                    item.day !== 'Sun'
                  ">
                  <div class="calendar-box {{ item.intervals[0].status }}">
                    <span class="{{ item.intervals[0].status }}">A</span>
                  </div>
                </div>
                <div class="col" *ngIf="item.day === 'Sat' || item.day === 'Sun'">
                  <div class="calendar-box disabled">
                    <span class="disabled"></span>
                  </div>
                </div>
                }
              </div>
            </div>
            <!-- Legend -->
            <div class="row mt-15">
              <div class="d-flex txt-regular align-items-center flex-wrap gap-2">
                <div class="d-flex align-items-center mr-3 mb-2">
                  <span class="legend-dot legend-dot-available"></span><span>Available</span>
                </div>
                <div class="d-flex align-items-center mr-3 mb-2">
                  <span class="legend-dot legend-dot-havent"></span><span>Haven’t Indicated</span>
                </div>
                <div class="d-flex align-items-center mr-3 mb-2">
                  <span class="legend-dot legend-dot-booked"></span><span>Booked</span>
                </div>
                <div class="d-flex align-items-center mr-3 mb-2">
                  <span class="legend-dot legend-dot-elsewhere"></span><span>Booked Elsewhere</span>
                </div>
                <div class="d-flex align-items-center mr-3 mb-2">
                  <span class="legend-dot legend-dot-unavailable"></span><span>Unavailable</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="row mt-20">
            <div class="col-lg-12 col-md-6 col-sm-8 col-12">
              <div class="promo-banner mb-3">
                <img src="../../../../assets/images/consumer/dash_background.png" alt="Background"
                  class="promo-banner-bg" />
                <img src="../../../../assets/images/consumer/dash_left.png" alt="Right Aligned"
                  class="promo-banner-img" />
                <div class="promo-banner-content" role="region" aria-label="Promotional course banner">

                  <!-- Headline -->
                  <h5 class="text-regular-bold fs-20" id="promoHeadline">
                    {{ promotion_course?.[0]?.headline }}
                  </h5>

                  <!-- CTA Button -->
                  <a appFocus [href]="promotion_course?.[0]?.cta_link" target="_blank" rel="noopener noreferrer"
                    class="btn cc_p_btn fs-14 mt-12" [attr.aria-label]="
      promotion_course?.[0]?.cta_text + 
      ' - ' + 
      promotion_course?.[0]?.headline + 
      ' (opens in new tab)'
    ">
                    {{ promotion_course?.[0]?.cta_text }}
                  </a>

                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="d-flex justify-content-between align-items-center mt-20">
              <h5 class="text-regular-bold fs-16">My Schools</h5>
            </div>
            <div class="card px-15">
              <div class="row align-items-center">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="d-flex align-items-center">
                    <div>
                      <h2 class="mb-0 text-regular-medium fs-32 clr-cc-vilot">
                        {{ school_count }}
                      </h2>
                    </div>
                    <div>
                      <p class="txt-regular fs-16 ml-10">
                        {{schoolProps.properties.is_qld_teacher? 'Schools are part of your My schools list' : 'Schools have added you to their list.'}}
                      </p>
                    </div>
                  </div>
                  <hr class="mt-10" />
                  <div class="">
                    <h5 class="text-regular-medium fs-16 align-self-center mb-0 mt-3">
                      Find new schools on ClassCover
                    </h5>
                    <p class="txt-regular mt-5 mb-5">
                      Browser schools in your area and request to join their list.
                    </p>
                    <a appFocus (click)="findNewSchools()" class="clr-cc-vilot fs-16 text-regular-bold"
                      role="button">Find new
                      schools
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-arrow-right" viewBox="0 0 16 17" stroke="currentColor" stroke-width="1">
                        <path fill-rule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8" />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>